module.exports = __webpack_public_path__ + "img/no-subscription.71d9bca1.svg";